import { render } from "./ModalWindow.vue?vue&type=template&id=c8144782&scoped=true&ts=true"
import script from "./ModalWindow.vue?vue&type=script&lang=ts"
export * from "./ModalWindow.vue?vue&type=script&lang=ts"

import "./ModalWindow.vue?vue&type=style&index=0&id=c8144782&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8144782"]])

export default __exports__